import axios from 'axios';
import { withReThrowingDataServiceError } from './data-service-api';
export class DataServiceHealthApiClient {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    healthCheck() {
        return withReThrowingDataServiceError(axios
            .get(`${this.baseUrl}/api/v1/health`)
            .then((it) => it.data));
    }
}
//# sourceMappingURL=data-service-health-api.js.map